import React from 'react'

const TotalNumber = ({ data, unit }) => {
  return (
    <div className="total-tile">
      <div className="total-number">{`${data.toLocaleString()}€`}</div>
      <div>{unit}</div>
    </div>
  )
}

export default TotalNumber
